/* CE · Wischen – macht seitlich scrollbare Leisten sichtbar.
   Aufbau: <div data-ce-wisch> <ul class="ce-wisch__liste">…</ul> {% render 'ce-wisch-fuss' %} </div>
   Setzt .ist-wischbar / .kann-links / .kann-rechts (Ausblenden am Rand, siehe ce-e.css),
   schaltet die Pfeil-Knöpfe und stößt die Leiste beim ersten Erscheinen kurz an
   (abschaltbar mit data-ce-wisch="ruhig"; entfällt bei „Bewegung reduzieren“). */
(function () {
  var ruhig = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(w) {
    if (w.__ceWisch) return; w.__ceWisch = true;
    var l = w.querySelector('.ce-wisch__liste'); if (!l) return;
    var zu = w.querySelector('.ce-wisch__knopf[data-richtung="-1"]');
    var vo = w.querySelector('.ce-wisch__knopf[data-richtung="1"]');

    function upd() {
      var m = l.scrollWidth - l.clientWidth, s = m > 4, x = l.scrollLeft;
      w.classList.toggle('ist-wischbar', s);
      w.classList.toggle('kann-links', s && x > 4);
      w.classList.toggle('kann-rechts', s && x < m - 4);
      if (zu) zu.disabled = !(x > 4);
      if (vo) vo.disabled = !(x < m - 4);
    }
    function geh(r) { l.scrollBy({ left: r * Math.max(160, l.clientWidth * 0.8), behavior: ruhig ? 'auto' : 'smooth' }); }

    if (zu) zu.addEventListener('click', function () { geh(-1); });
    if (vo) vo.addEventListener('click', function () { geh(1); });
    l.addEventListener('scroll', upd, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(upd).observe(l); else addEventListener('resize', upd);
    upd();

    if (!ruhig && w.getAttribute('data-ce-wisch') !== 'ruhig' && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) {
        if (!e[0].isIntersecting) return;
        io.disconnect();
        if (!w.classList.contains('kann-rechts') || l.scrollLeft > 4) return;
        setTimeout(function () {
          l.scrollBy({ left: 56, behavior: 'smooth' });
          setTimeout(function () { l.scrollBy({ left: -56, behavior: 'smooth' }); }, 450);
        }, 300);
      }, { threshold: 0.6 });
      io.observe(l);
    }
  }

  function alle(root) { (root || document).querySelectorAll('[data-ce-wisch]').forEach(init); }
  document.addEventListener('shopify:section:load', function (e) { alle(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { alle(); }); else alle();
})();
